// extracted by mini-css-extract-plugin
export var actionIcon = "_q9-0";